module.exports = __webpack_public_path__ + "static/media/error.a4194821.wav";